import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgFileUnlockSimpleIcon = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "File icon with a simple unlock symbol in the center",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}

    <g clipPath="url(#clip0_25518_76671)">
      <path
        d="M15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 2.5V6.875H16.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_25518_76671)">
      <path
        d="M12.5 10.75H7.5C7.36193 10.75 7.25 10.8619 7.25 11V14.5C7.25 14.6381 7.36193 14.75 7.5 14.75H12.5C12.6381 14.75 12.75 14.6381 12.75 14.5V11C12.75 10.8619 12.6381 10.75 12.5 10.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 10.75V9.75C8.75 9.41848 8.8817 9.10054 9.11612 8.86612C9.35054 8.6317 9.66848 8.5 10 8.5C10.3315 8.5 10.6495 8.6317 10.8839 8.86612"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_25518_76671">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_25518_76671">
        <rect
          width="8"
          height="8"
          fill="white"
          transform="translate(6 8)"
        />
      </clipPath>
    </defs>
  </svg>
);

const FileUnlockSimpleIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgFileUnlockSimpleIcon />
  </BaseIcon>
);

export default FileUnlockSimpleIcon;
